'use client'

import React from 'react'
import Button from '@mui/material/Button'
import LoadingButton from '@mui/lab/LoadingButton'
import { ButtonProps as MuiButtonProps } from '@mui/material'

/************************************************************************
  #### 이름 : `CustomButtonProps`
  #### 설  명 : 커스텀 버튼 props의 타입을 정의한 인터페이스  
  #### 프로퍼티 :  

  > - loading(boolean): 로딩버튼의 로딩상태
  > - customText(string): 버튼에 표시할 텍스트
 ************************************************************************/
interface CustomButtonProps extends MuiButtonProps {
  loading?: boolean // disalbed는 ButtonProps에 포함되어 있지만 loading은 없으므로 추가해야 함
  customText?: string
}

/************************************************************************
  #### 이름 : `CustomButton`
  #### 설  명 : MUI 버튼 컴포넌트에 동적으로 props를 넣기 위한 컴포넌트 
  #### 인  자 :  

  > - customText(string): 버튼에 표시할 텍스트
  > - children(React.ReactNode): 리액트로부터 넘겨받는 컨텐츠
  > - ...props: MUI 버튼 컴포넌트에 주입할 props
 ************************************************************************/
export const CustomButton = ({
  customText,
  children,
  ...props
}: CustomButtonProps) => {
  return <Button {...props}>{customText || children}</Button>
}

/************************************************************************
  #### 이름 : `CustomLoadingButton`
  #### 설  명 : MUI 로딩버튼 컴포넌트에 동적으로 props를 넣기 위한 컴포넌트 
  #### 인  자 :  

  > - customText(string): 버튼에 표시할 텍스트
  > - children(React.ReactNode): 리액트로부터 넘겨받는 컨텐츠
  > - ...props: MUI 로딩버튼 컴포넌트에 주입할 props
 ************************************************************************/
export const CustomLoadingButton = ({
  customText,
  children,
  ...props
}: CustomButtonProps) => {
  return <LoadingButton {...props}>{customText || children}</LoadingButton>
}
